//! The content of this file will be replaced with the content of /ENV.js during yarn serve

export const ENV: Record<string, string> = (window as any).ENV;
